/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import AnimatedCard from "../../app/components/AnimatedCard";
import frameMap from "../../.cache/search/first-frame-map.json";
function _createMdxContent(props) {
  return <AnimatedCard href={props.record?.href} title={props.record?.title || props.record?.href || "Untitled"} src={props.record?.type === "work" ? props.record?.thumbnail : undefined} staticSrc={frameMap[props.record?.thumbnail?.split("/").pop()?.replace(".gif", "")]} imgWidth={props.record?.thumbnailWidth} imgHeight={props.record?.thumbnailHeight} aspectRatio={props.thumbnailAspectRatio} />;
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
